import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { advKeywords: { getAdvKeywords, } } = apiUrls;

export const ADV_KEYWORDS_SUCCESS = 'ADV_KEYWORDS_SUCCESS';
export const ADV_KEYWORDS_LOADING = 'ADV_KEYWORDS_LOADING';


export const getAdvKeywordsData = ({ country, fromdate, todate }) => async (dispatch) => {
        try {
            const { url } = getAdvKeywords
            const requestData = {
                ...getAdvKeywords,
                url: url.replace('{{country}}', country).
                replace('{{fromdate}}', fromdate).replace('{{todate}}', todate)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: ADV_KEYWORDS_SUCCESS,
                data,
            })
        } catch (e) {

            dispatch({
                type: ADV_KEYWORDS_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                }
            })
        }

    }



export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: ADV_KEYWORDS_LOADING,
        isLoading
    })
}
